module.exports = __webpack_public_path__ + "static/media/3.3f9d888b.png";